(function ($, router) {    

	router.goto = function (path, isFullLink, fromHistory) {
		var link = router.pathOfRighteousness(path, isFullLink);
		if (History.enabled) {
		    var origLink = link;
		    if (router.defaults.relativeUrl){
				
			}else{
		    if (origLink.substr(0, 4) !== "http")
		      origLink = window.location.protocol + link;  
		    }  
		    // mičem hash zbog IE9 podrške
		    var s = origLink.split("#");
		    origLink = s[0];
		    History.pushState({ rand: Math.random() }, "", origLink);
		}
		else {
		    window.location.assign(link);
		}
	};
	
	// postavlja link u adress bar bez refreshanja (html5)
	router.setUrl = function(title, url, obj) {
	    if (History.emulated.pushState === false) {
    		var obj = typeof obj === 'undefined' ? {} : obj;
    		// History.pushState refresha odmah - to ne želimo u ovom slučaju
    		history.pushState(obj, title, url);		
		}
		document.title = title;  
	};
	
	router.gotoLocation = function (path, isFullLink) {
		var link = router.pathOfRighteousness(path, isFullLink);
		
		window.location.assign(link);
	};
	
	router.gotoLocationPost = function (path, params, addHtml, isFullLink) {		
		var link = router.pathOfRighteousness(path, isFullLink);
		var html = "<form id='freeForm' action='" + link + "' method='post' >";	
		var html = html + addHtml;
		for(i=0; i<params.length; i++){
			html = html + "<input type='hidden' name='param_" + i +"' value='" + params[i] + "' >";	
		}		
		html = html + "</form>";		
		$("#freeHTML").append(html);
		$("#freeForm").submit();
	};	
	
	router.gotoLocationNewtab = function (path, isFullLink) {
		var link = router.pathOfRighteousness(path, isFullLink);
		
		window.open(link, '_blank');
	};
	
	router.pathOfRighteousness = function (path, isFullLink) {
		if (typeof isFullLink === "undefined") {
			isFullLink = KUtils.isAbsoluteUrl(path);
		}
		
		if (isFullLink === true || path.startsWith(router.defaults.modulBasePath))
			return path;
		else
			return router.getModulPath(path);
	};
	
	router.getModulPath = function (path) {
		if (router.defaults.relativeUrl){
			if (path.startsWith('http://') || path.startsWith('https://')) {
				return path.replace(/^https?:\/\//, "//");;	
			}else if (path.startsWith(router.defaults.modulBasePath)){
				return path;	
			}else{
				return router.defaults.modulBasePath + path;	
			}	
		}else{
			return KUtils.isAbsoluteUrl(path) ? path : router.defaults.modulBasePath + path;	
		}	
	};
	
	router.getPath = function (path) {
		return KUtils.isAbsoluteUrl(path) ? path : router.defaults.basePath + path;
	};
	
	router.gotoPost = function (path, params) {
		var fullPath = router.getModulPath(path);
		var form = $("<form action=\"" + fullPath + "\" method=\"post\"></form>");
		// kreiram inpute.^
		$.each(params, function (key, value) {
			var input = $("<input type=\"hidden\" name=\"" + key + "\" />");
			input.val(value);
			input.appendTo(form);
		});
		$("body").append(form);
		$(form).submit();
	};
	
	router.getHref = function () {
	   if (History.enabled) {
	       var s = History.getState(); 
	       if (s && s.url) {
	           return s.url;
	       }    
	   }
	   return window.location.href;
	};
	
	router.isAjaxLoading = function () {
	   return (router.defaults.ajaxLoading === true) && history.pushState; // IE9 ne podržava  
	};
	
	router.getModalIdFromLink = function (link) {
    	if (!link || link.split('/').length < 2)
    		return 'modal-'+(new Date()).valueOf().toString();
    		
    	var link = link.toLowerCase();
    		link = link.split('/');
    	
    	return 'modal-'+link[0]+'-'+link[1];
   	};
	
	router.defaults = {
		basePath: "",
		modulBasePath: "",
		ajaxLoading: true,
		kssApp: "",
		relativeUrl: false		
	};
    
    $(document).ready(function () {
        if (History.enabled) {
            History.Adapter.bind(window, "statechange", function () {
                var state = History.getState();
                var url = state ? state.url : window.location.href;
                if (state === null) {
                    window.location.href = window.location.href;
                }
                else {
                    $(window).trigger("beforepageunload");
                    $(document).trigger("ajaxAbort");
                    $(".kontomodal").each(function (ind, el) {
                        var modal = $(this).data("kendoKontoModal");
                        if (modal) {
                            modal.destroy();
                        }   
                    });
                    
                    //TODO: busy bi trebao biti bolje rješenje po meni.
                    //KUtils.busy();
                    var content = $("#ajax-content");
                    /**
                     * Destroy svih kendo elemenata. Primjerice combobox popupovi se spremaju u body i kod navigacije
                     * ostaju u bodyju - memory leak.
                     */ 
                    kendo.destroy(content);
                    content.children().detach();
                    content.html("Učitavanje stranice u tijeku...");
                    url = KUtils.addParamToUrl(url, "view_as", "json");
                    $.ajax({
                       url: url,
                       dataType: "json"
                    }).done(function (data, textStatus, jqXHR) {
                        document.title = data.title;
                        $(document).trigger("pageLoaded", { 
                            data: data,
                            title: data.title,
                            url: url
                        });
                        
                        content.html(data.content);
                        //KUtils.busy(false);
                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        /*
                        konto.dialogs.modal({
                            title: "Obavijest",
                            content: "Stranica nije dohvaćena" 
                        });
                        */
					   	$('#page-title').html('Greška');
					   	
					   	var greska = "Sesija je istekla. Kliknite na izbornik ili osvježite stranicu (F5).";
					   	if (jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.error){
							greska = "<div class='h4'>" + jqXHR.responseJSON.error +"</div>"; 	   
						}
					   	
                        content.html(greska + "</br><a href='javascript:history.back()'>Vrati se na prethodnu stranicu</a>");
                    });
                }
                //router.goto(url, undefined, true);
                //return true;   
            }); 
            
        }   
    });
    /*
    if (router.isAjaxLoading()) {
        window.onpopstate = function (event) {
            var url = event.state !== null ? event.state.url : window.location.href;
            router.goto(url, undefined, true);
            return true;
        };
    }
    */
} (jQuery, window.kontorouter = window.kontorouter || {}));